// import { DataStoreLoadGame } from '../../../data/usecases/games/data-store-load-game'
import { RemoteLoadGame } from '../../../data/usecases/games/remote-load-game'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeLoadGame = (slug: string): RemoteLoadGame => {
  return new RemoteLoadGame(`/public/games/${slug}`, makeAxiosHttpClient())
}

export const makeTeamByCode = (slug: string): RemoteLoadGame => {
  return new RemoteLoadGame(`/public/teams/code/${slug}`, makeAxiosHttpClient())
}

export const makeLoadBySlug = (): RemoteLoadGame => {
  return new RemoteLoadGame('/public/games/code', makeAxiosHttpClient())
}

// export const makeQueryGame = (): DataStoreLoadGame => {
//   return new DataStoreLoadGame()
// }
